import { render, staticRenderFns } from "./DeleteArea.vue?vue&type=template&id=6d0794a4&scoped=true&"
import script from "./DeleteArea.vue?vue&type=script&lang=js&"
export * from "./DeleteArea.vue?vue&type=script&lang=js&"
import style0 from "./DeleteArea.vue?vue&type=style&index=0&id=6d0794a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0794a4",
  null
  
)

export default component.exports